import { BASE_URL } from '../constants';
import { getItem } from '../utils/localStore';
import { errorHandling, errorHandler } from '../utils/errorHandling';
class brochureUrlApi {
    static brochureUrl(file, ticker_symbol) {
        const TOKEN = getItem('auth_token');
        const data = new FormData();
        data.append('file', file[0]);
        let isError = false;
        try{
            const ajaxRequestHeaders = new Headers({
                'Authorization': TOKEN,
                mimeType: 'multipart/form-data',
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: data
            }
            return fetch(BASE_URL + `/offerings/uploadfile?ticker_symbol=${ticker_symbol}`, body).then(response => {

                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default brochureUrlApi;